import Translation from 'components/Translation'
import { useAppContext } from 'context/AppContext'
import { AddIcon } from 'utils/custom-icons'
import { classNames } from 'utils/dom-helpers'
import { getTranslation } from 'utils/language-helper'
export type StaffListItemProps = {
    id: string
    staff_user_id: string
    first_name: string
    last_name: string
    staff_image?: string
    is_selected?: boolean
    onClick?(): void
    selectItem?(): void
}
export function StaffListItem({
    first_name,
    last_name,
    id,
    staff_user_id,
    staff_image,
    is_selected,
    onClick,
    selectItem,
}: StaffListItemProps) {
    const { translations } = useAppContext()
    return (
        <div
            className={classNames(
                'flex items-center gap-3 px-2 py-1 justify-between',
                is_selected ? 'bg-primary text-white' : ''
            )}
            onClick={onClick}
        >
            <div className="rounded-full w-10 h-10 overflow-hidden block bg-gray-100 flex items-center justify-center">
                {staff_image ? (
                    <img
                        className="max-w-full max-h-full"
                        src={staff_image}
                        alt="Staff Image"
                    />
                ) : (
                    <i className="feather-user text-xl text-primary" />
                )}
            </div>
            <div className="text-left flex-1 flex flex-col">
                <div>
                    {first_name} {last_name}
                </div>
            </div>
            <button
                type="button"
                onClick={selectItem}
                // className={classNames(
                //     is_selected
                //         ? 'text-primary-lighter'
                //         : 'text-primary-light'
                // )}
                title={getTranslation(
                    'add_staff',
                    translations
                )}
            >
                <AddIcon/>
                {/* <Translation 
                    content_key="add_staff"
                /> */}
            </button>
        </div>
    )
}

export default StaffListItem
